// extracted by mini-css-extract-plugin
module.exports = {"BuildConrtols":"BuildControls_BuildConrtols__3W1Ky","OrderButton":"BuildControls_OrderButton__zz3xr","enable":"BuildControls_enable__1g9RK"};